module.exports = __webpack_public_path__ + "static/media/Low.b6954dde.svg";